import { render, staticRenderFns } from "./NotificationActivityInfoModal.vue?vue&type=template&id=1f926af4&scoped=true"
import script from "./NotificationActivityInfoModal.vue?vue&type=script&lang=js"
export * from "./NotificationActivityInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f926af4",
  null
  
)

export default component.exports